export const Config = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*'
  },

  baseUrl: import.meta.env.VITE_BACKEND_BASE_URL,
  store: 'store/',
  user: 'user/',
  barcode: 'barcode/',
  barcodeTemplate: 'barcode_template',
  inventory: 'inventory/',
  bulkInventory: 'batch_inventory/',
  productSearch: 'product_search/',
  product: 'product/',
  customFields: 'custom_fields',
  sku: 'sku/',
  search: 'find',
  replace: 'replace',
  delete: 'delete',
  generate: 'generate',
  generateAll: 'generate_all',
  batches: 'batches',
  download: 'download',
  update: 'update',
  preview: 'preview',
  print: 'print',
  addInventory: 'add_inventory',
  subtractInventory: 'subtract_inventory',
  setInventory: 'set_inventory',
  scanInventory: 'scan_inventory',
  batchResults: 'batch',
  allResults: 'results',
  batchReport: 'report',
  settings: 'settings',
  locations: 'locations',
  transferInventory: 'transfer_inventory',
  payment: 'payment/',
  session: 'session',
  verify: 'verify',
  imageCheck: 'image_check',
  fungibles: 'fungibles',
  lineSettings: 'line_settings',
  upgrade: 'upgrade',
  categories: 'categories',
  brands: 'brands',
  order: 'order',
  order_statuses: 'order_statuses',
  orders: 'orders/',
  upload: 'upload',
  incomplete: 'incomplete',
  shipments: 'shipments',
  warehouseReceivingOrders: 'warehouse_receiving_orders',
  warehouseReceivingOrder: 'warehouse_receiving_order/',
}
